module.exports = __webpack_public_path__ + "02be191affae28bdcc963795190a5425.png";